import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, ...props }) => {
  const IconComponent = icon;

  if (!IconComponent) {
    console.warn("SafeIcon: 'icon' prop is missing. Rendering fallback icon.");
    return <FiAlertTriangle {...props} />;
  }

  return React.createElement(IconComponent, props);
};

export default SafeIcon;